import { AggregationDefinition } from '../aggregation/aggregation-definition.js';
import { AggregateHostRuntime } from './host-runtime.js';
import { StateDeclarations } from '../storage/state-declaration.js';
import { RealmDefinition } from '../realm/realm-definition.js';
import { AuthProviders } from '../authentication/auth-providers.js';
import { AggregationEventDeclaration } from '../aggregation/aggregation-event-declaration.js';
import { createHostRuntime } from './create-host-runtime.js';
import { HandleDeclarations } from '../stream/handle-declarations.js';
import { EventDeclaration } from '../event-store/event-declarations.js';

export function createAggregateHost<
  TState extends StateDeclarations,
  TEvent extends AggregationEventDeclaration<any>,
  TRealm extends RealmDefinition<AuthProviders>,
>(
  agg: AggregationDefinition<TState, TEvent, any, TRealm>,
): AggregateHostRuntime<TState, TRealm> {
  const handles: HandleDeclarations<TState, any, {}> = {};
  const events: Record<string, EventDeclaration<any>> = {};

  for (const [eventKey, handle] of Object.entries(agg.events)) {
    if ('event' in handle) {
      handles[handle.event] = agg.handle[eventKey];
      events[handle.event] = {
        type: handle.type.type,
        schema: handle.type.schema,
        key: handle.event,
      };
    } else {
      handles[handle.output] = agg.handle[eventKey];
      events[handle.output] = {
        type: handle.type.type,
        schema: handle.type.schema,
        key: handle.output,
      };
    }
  }

  return {
    source: agg,
    runtime: createHostRuntime(events, handles, {}),
  };
}
